var Carousel = (function($) {

  var init = () => {
    // _initSearch();
    _initScroll();
  };

  // var _initSearch = () => {
  //   let $primaryHeader = $('#header-primary');
  //   let $searchInput = $primaryHeader.find('form input');
  //   let $searchBtn = $primaryHeader.find('button.search');

  //   $searchBtn.on('click', (e) => {
  //     e.preventDefault();
  //     $searchInput.toggleClass('hidden');
  //     $searchInput.focus();
  //   });
  // };

  var _initScroll = () => {
    // Calculate header height add padding to .page-wrap
    // This ensures that if more menu items are added, layout works
    let $primaryHeader = $('#header-primary');
    let $pageWrap = $('.page-wrap');
    let headerHeight = $primaryHeader.outerHeight();

    $pageWrap.css({
      'padding-top': headerHeight
    }).addClass('loaded');

    $(window).on('resize', function(e) {
      if ($(window).width() < 992) {
        $pageWrap.css({
          'padding-top': '80px'
        });
      } else {
        headerHeight = $primaryHeader.outerHeight();

        $pageWrap.css({
          'padding-top': headerHeight
        });
      }
    });
  };

  module.exports = {
    init: init
  };

})(jQuery);
